export default __webpack_public_path__ + "static/media/video8.94fa22a4.webp";